// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2b25f32b","384":"bb9a8928","416":"8e647274","538":"893e83c1","566":"5ca475da","614":"c4022a98","676":"8b16acba"}[chunkId] + ".chunk.js";
};